import React, { Component } from "react";

import {
  CListGroup,
  CListGroupItem,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import AcertosPorAssunto from "../../../../components/Statistics/AlocacaoAcertosAssunto";
import AcertosPorQuestao from "../../../../components/Statistics/AlocacaoAcertosQuestao";
import DataQ from "../../../../components/Statistics/DataQuestions/index";
import Chart1 from "../../../../components/Statistics/HistogramaDaTurma/index";
import ListaNotas from "../../../../components/Statistics/ListaNotas";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
// import ProtectedRoute from "../../../../components/ProtectedRoute";
import { log } from "../../../../utils/log";
// import Desempenho from "../../../../components/Statistics/desempenhoPorAssunto/index";
// import TabelaDesempenho from "../../../../components/Statistics/tabelaDesempenho/index";
// import AtividadeAluno from "../../../../components/Statistics/atividadeAluno";
// import AtividadeTurma from "../../../../components/Statistics/ResumoAtividade";
// import ListaAtividadeTurma from "../../../../components/Statistics/listaAtividadeTurma";

import "./style.css";

// import AssuntoAvaliacao from "../../../../components/Statistics/Comparison/AssuntoAvaliacao";
// import AlunoEscola from "../../../../components/Statistics/Comparison/alunoEscola";
// import AlunoRede from "../../../../components/Statistics/Comparison/AlunoRede";
// import AlunoTurma from "../../../../components/Statistics/Comparison/AlunoTurma";
// import HistogramaAluno from "../../../../components/Statistics/Comparison/HistogramaAluno";
// import EntreTurmas from "../../../../components/Statistics/Comparison/EntreTurmas";
// import AssuntoAvaliacaoEscola from "../../../../components/Statistics/Comparison/AssuntoAvaliacaoEscola";
// import AssuntoAvaliacaoTurma from "../../../../components/Statistics/Comparison/AssuntoAvaliacaoTurma";
// import HistogramaTurma from "../../../../components/Statistics/Comparison/HistogramaTurma";
// import HistogramaEscola from "../../../../components/Statistics/Comparison/HistogramaEscola";

class EvaluationStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      // loading: true,
      applications: [],
      menu: "Histograma da Turma"
    };
  }

  async componentDidMount() {
    const respApplications = await axios.get(
      `${URL.api}evaluation/application/report?allocation_id=${this.props.allocation_id}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );
    const respList = await axios.get(
      `${URL.api}evaluation/question/lists/singleViewWithOptions/${respApplications.data.data[0]?.list_id}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState(
      {
        applications: respApplications.data.data,
        list: respList.data.data
      },
      () => this.createLog()
    );
  }

  createLog() {
    log(
      "access",
      this.props.currentRoute,
      `Acessou as estatísticas da lista ${this.state.list?.name}${
        this.props.activity
          ? ` dentro da atividade com id ${this.props.activity}`
          : ""
      }`,
      this.state.list?.id,
      this.props.user.token,
      this.props.activity || null,
      this.props.general.active_roles.school_id || null
    );
  }

  getMenus() {
    return [
      {
        name: "Histograma da Turma",
        component: <Chart1 applications={this.state.applications} />
      },
      {
        name: "Lista de Notas",
        component: <ListaNotas applications={this.state.applications} />
      },
      {
        name: "Avaliação - Descritor e Distrator",
        component: (
          <DataQ
            applications={this.state.applications}
            list={this.state.list}
          />
        )
      },
      {
        name: "Acertos por Questão",
        component: (
          <AcertosPorQuestao
            applications={this.state.applications}
            list={this.state.list}
          />
        )
      },
      {
        name: "Acertos por Assunto",
        component: (
          <AcertosPorAssunto
            applications={this.state.applications}
            list={this.state.list}
          />
        )
      }
    ];
  }

  render() {
    return (
      <CModal
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>
            Estatísticas da avaliação - {this.state.list?.name}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <CListGroup
            style={{
              height: "100%",
              backgroundColor:
                "#f6f8f9" /* , borderRight:"1px solid rgba(0, 0, 21, 0.125)" */
            }}
          >
            {this.getMenus().map((menu, index) => (
              <React.Fragment key={index}>
                <CListGroupItem
                  action
                  active={menu.name === this.state.menu}
                  style={{ border: "0", borderRadius: "0", minWidth: "250px" }}
                  className="cursor"
                  onClick={() => this.setState({ menu: menu.name })}
                >
                  {menu.name}
                </CListGroupItem>
              </React.Fragment>
            ))}
          </CListGroup>
          <div
            className="p-3 charts flex-1 d-flex flex-column align-items-center"
            style={{ overflow: "auto" }}
          >
            <span className="est-text mb-3">
              <h1>{this.state.menu}</h1>
            </span>
            {
              this.getMenus().find(menu => menu.name === this.state.menu)
                .component
            }
          </div>
        </CModalBody>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationStatistics);
